export const zeroPad = (num, places = 8) => String(num).padStart(places, '0');

export function formatNumber(x) {
    if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return '';
}